export default __webpack_public_path__ + "static/media/x.9f7124b9.svg";